import { render, staticRenderFns } from "./PromptModal.vue?vue&type=template&id=8aa83cdc&"
import script from "./PromptModal.vue?vue&type=script&lang=js&"
export * from "./PromptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports